import React, { type CSSProperties } from "react";

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned actions (buttons, selects) */
  children?: React.ReactNode;
}

/**
 * Standard admin page header: title, one-line purpose, actions on the right.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children }) => (
  <div style={styles.header}>
    <div style={{ minWidth: 0 }}>
      <h2 style={styles.title}>{title}</h2>
      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
    </div>
    {children && <div style={styles.actions}>{children}</div>}
  </div>
);

const styles: Record<string, CSSProperties> = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
    marginBottom: 18,
    flexWrap: "wrap",
  },
  title: { margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: "-0.01em", color: "#111827" },
  subtitle: { fontSize: 13, color: "#6b7280", marginTop: 2 },
  actions: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
};

export default PageHeader;
